
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, Input, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AssistBotService } from '../assist-bot.service';
import * as CryptoJS from 'crypto-js';
import { NotifierService } from '../../../../services/Notifierservice';
import { LoginService } from '../../../../components/login/service/login.service';

declare const $: any;

@Component({
  standalone: false,
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bot.component.scss'],
})
export class BotComponent implements OnInit {
  volumeicons: any = ['fa fa-volume-off', 'fa fa-volume-up'];
  @Input() data: any;

  @Input() index: any;
  @Input() speakeLanguage: any;

  showPaginateSpinner: boolean = false;

  public isActiveFeedback: boolean = false;

  synth = window.speechSynthesis;

  commentForm: FormGroup = new FormGroup({});
  showuserIcon: boolean = false;

  userDetails: any;
  llm_url: any;
  constructor(
    private readonly fb: FormBuilder,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly notifier: NotifierService,
    private readonly http: HttpClient,
    private readonly assistBotService: AssistBotService,
    private readonly service: LoginService,
  ) {}

  ngOnInit() {
    let user = localStorage.getItem('user');
    if (user) {
      let data = CryptoJS.AES.decrypt(user, this.service.enCryptKey).toString(
        CryptoJS.enc.Utf8,
      );
      this.userDetails = JSON.parse(data);
    }
    this.llm_url = 'https://document.canstringai.com:8443/upload_document/';

    this.commentForm = this.fb.group({
      comment: new FormControl('', Validators.required),
    });
    this.showPaginateSpinner = true;
    if (this.data.bot_answer) {
      this.showPaginateSpinner = false;
    }

    let headers: any = new Headers();
    headers.append('Content-Type', 'application/json');

    if (this.data?.search && this.data?.bot_type !== 'suggestion') {
      this.showPaginateSpinner = true;
      const payload = {
        query: this.data.question,
        clientid: this.userDetails['userid'],
      };

      this.http
        .post(this.llm_url + 'query', payload, { headers: headers })
        .subscribe({
          next: (response: any) => {
            this.showPaginateSpinner = false;

            this.data['question_type'] = 'history';
            this.data['sequence_id'] = new Date().valueOf();
            this.data['created_at'] = new Date();
            this.data['bot_answer'] = response['result'];
            this.data['search'] = false;
          },
          error: (error: HttpErrorResponse) => {
            this.showPaginateSpinner = false;
            this.notifier.notify('error', 'Please Upload document');
            this.data['question_type'] = 'history';
          },
        });
    }
  }

  speakText(state: boolean, textdata: string) {
    let voices = this.synth.getVoices();

    let speakLanguage: any, defaultVoice: any;

    if (this.speakeLanguage === 'hindi') {
      speakLanguage = 'Google हिन्दी';
      defaultVoice = 'Microsoft Kalpana - Hindi (India)';
    } else if (this.speakeLanguage === 'spanish') {
      speakLanguage = 'Google español';
      defaultVoice = 'Microsoft Helena - Spanish (Spain)';
    } else {
      speakLanguage = 'Google UK English Female';
      defaultVoice = 'Microsoft Heera - English (India)';
    }

   const botVoice = voices.findIndex(
  (item) => item.name === speakLanguage
);

const botDefaultVoice = voices.findIndex(
  (item) => item.name === defaultVoice
);

    let text = textdata.replace(/(<([^>]+)>)/gi, '');
    if ('speechSynthesis' in window) {
      let utterThis = new SpeechSynthesisUtterance(text);

      utterThis.voice =
        botVoice > -1 ? voices[botVoice] : voices[botDefaultVoice];
      if (state) {
        speechSynthesis.cancel();
        if (this.speakeLanguage === 'hindi') {
          utterThis.lang = 'hi-IN';
        } else if (this.speakeLanguage === 'spanish') {
          utterThis.lang = 'es-ES';
        } else {
          utterThis.lang = 'en-IN';
        }

        window.speechSynthesis.speak(utterThis);
      } else {
        speechSynthesis.cancel();
      }
    } 
  }

  showFeedbackform() {
    this.isActiveFeedback = !this.isActiveFeedback;
  }

  changeNewLine(answer: any) {
    return answer.replace(/\n\r?/g, '<br />');
  }

  refresh() {
    this.data['created_at'] = new Date();
  }
}
